import { render, staticRenderFns } from "./timePrizePool.vue?vue&type=template&id=60f50ba4&"
import script from "./timePrizePool.vue?vue&type=script&lang=js&"
export * from "./timePrizePool.vue?vue&type=script&lang=js&"
import style0 from "./timePrizePool.vue?vue&type=style&index=0&id=60f50ba4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports